import CLIENTS from './CLIENTS.svg';
import CLIENTS_XS from './CLIENTS_XS.svg';
import BLOG_CARD_1 from './Blog/BLOG_CARD_1.png';
import BLOG_CARD_2 from './Blog/BLOG_CARD_2.png';
import BLOG_CARD_3 from './Blog/BLOG_CARD_3.png';
import STEP_BUTTON_1 from './Process/STEP_BUTTON_1.png';
import STEP_BUTTON_2 from './Process/STEP_BUTTON_2.png';
import STEP_BUTTON_3 from './Process/STEP_BUTTON_3.png';
import STEP_BUTTON_4 from './Process/STEP_BUTTON_4.png';
import CAPABILITY_3DP from './ServiceType/CAPABILITY_3DP.png';
import CAPABILITY_CASTING from './ServiceType/CAPABILITY_CASTING.png';
import CAPABILITY_CNC from './ServiceType/CAPABILITY_CNC.png';
import CAPABILITY_MD from './ServiceType/CAPABILITY_MD.png';
import CAPABILITY_MOLDING from './ServiceType/CAPABILITY_MOLDING.png';
import CAPABILITY_PD from './ServiceType/CAPABILITY_PD.png';
import CAPABILITY_SHEETMETAL from './ServiceType/CAPABILITY_SHEETMETAL.png';
import PROCESSMETHOD_CNC_DRILLING from './ProcessMethods/PROCESSMETHOD_CNC_DRILLING.png';
import PROCESSMETHOD_CNC_MACHINING_CENTER from './ProcessMethods/PROCESSMETHOD_CNC_MACHINING_CENTER.png';
import PROCESSMETHOD_CNC_MILLING from './ProcessMethods/PROCESSMETHOD_CNC_MILLING.png';
import PROCESSMETHOD_CNC_TURNING from './ProcessMethods/PROCESSMETHOD_CNC_TURNING.png';
import PROCESSMETHOD_PRINTING_FDM from './ProcessMethods/PROCESSMETHOD_PRINTING_FDM.png';
import PROCESSMETHOD_PRINTING_MJF from './ProcessMethods/PROCESSMETHOD_PRINTING_MJF.png';
import PROCESSMETHOD_PRINTING_POLYJET from './ProcessMethods/PROCESSMETHOD_PRINTING_POLYJET.png';
import PROCESSMETHOD_PRINTING_SLA from './ProcessMethods/PROCESSMETHOD_PRINTING_SLA.png';
import PROCESSMETHOD_PRINTING_SLM_DMLS from './ProcessMethods/PROCESSMETHOD_PRINTING_SLM_DMLS.png';
import PROCESSMETHOD_PRINTING_SLS from './ProcessMethods/PROCESSMETHOD_PRINTING_SLS.png';
import PROCESSMETHOD_MOLDING_INJECTION from './ProcessMethods/PROCESSMETHOD_MOLDING_INJECTION.png';
import PROCESSMETHOD_MOLDING_DOUBLE_INJECTION from './ProcessMethods/PROCESSMETHOD_MOLDING_DOUBLE_INJECTION.png';
import PROCESSMETHOD_MOLDING_BLOW_INJECTION from './ProcessMethods/PROCESSMETHOD_MOLDING_BLOW_INJECTION.png';
import PROCESSMETHOD_MOLDING_INSERT_INJECTION from './ProcessMethods/PROCESSMETHOD_MOLDING_INSERT_INJECTION.png';
import PROCESSMETHOD_SHEETMETAL_PRESS from './ProcessMethods/PROCESSMETHOD_SHEETMETAL_PRESS.png';
import PROCESSMETHOD_SHEETMETAL_LASER_CUTTING from './ProcessMethods/PROCESSMETHOD_SHEETMETAL_LASER_CUTTING.png';
import PROCESSMETHOD_SHEETMETAL_WATERJET_CUTTING from './ProcessMethods/PROCESSMETHOD_SHEETMETAL_WATERJET_CUTTING.png';
import PROCESSMETHOD_CASTING_SAND from './ProcessMethods/PROCESSMETHOD_CASTING_SAND.png';
import PROCESSMETHOD_CASTING_SHELL from './ProcessMethods/PROCESSMETHOD_CASTING_SHELL.png';
import PROCESSMETHOD_CASTING_INVESTMENT from './ProcessMethods/PROCESSMETHOD_CASTING_INVESTMENT.png';
import PROCESSMETHOD_CASTING_DIE from './ProcessMethods/PROCESSMETHOD_CASTING_DIE.png';
import PROCESSMETHOD_CASTING_CENTRIFUGAL from './ProcessMethods/PROCESSMETHOD_CASTING_CENTRIFUGAL.png';
import PROCESS_STEP1_1 from './Process/PROCESS_STEP1_1.png';
import PROCESS_STEP2 from './Process/PROCESS_STEP2.png';
import PROCESS_STEP3 from './Process/PROCESS_STEP3.png';
import PROCESS_STEP4 from './Process/PROCESS_STEP4.png';
import PROCESS_STEP1_XS from './Process/PROCESS_STEP1_XS.png';
import PROCESS_STEP2_XS from './Process/PROCESS_STEP2_XS.png';
import PROCESS_STEP3_XS from './Process/PROCESS_STEP3_XS.png';
import PROCESS_STEP4_XS from './Process/PROCESS_STEP4_XS.png';

import HERO from './Hero/HERO.jpg';
import HERO_MD from './Hero/HERO_MD.png';
import HERO_XS from './Hero/HERO_XS.png';
import QUESTION_Q from './QUESTION_Q.png';
import ANSWER_A from './ANSWER_A.png';
import TECH_INSIDE_BACKGROUND from './TECH_INSIDE_BACKGROUND.png';
import TECH_INSIDE_MIDDLE_PNG from './TECH_INSIDE_MIDDLE_PNG.png';

const processImages = {
  PROCESS_STEP1_1,
  PROCESS_STEP2,
  PROCESS_STEP3,
  PROCESS_STEP4,
  PROCESS_STEP1_XS,
  PROCESS_STEP2_XS,
  PROCESS_STEP3_XS,
  PROCESS_STEP4_XS
};

const capabilityImages = {
  CAPABILITY_3DP,
  CAPABILITY_CASTING,
  CAPABILITY_CNC,
  CAPABILITY_MD,
  CAPABILITY_MOLDING,
  CAPABILITY_PD,
  CAPABILITY_SHEETMETAL
};

const processmethodImages = {
  PROCESSMETHOD_CNC_DRILLING,
  PROCESSMETHOD_CNC_MACHINING_CENTER,
  PROCESSMETHOD_CNC_MILLING,
  PROCESSMETHOD_CNC_TURNING,
  PROCESSMETHOD_PRINTING_FDM,
  PROCESSMETHOD_PRINTING_MJF,
  PROCESSMETHOD_PRINTING_POLYJET,
  PROCESSMETHOD_PRINTING_SLA,
  PROCESSMETHOD_PRINTING_SLM_DMLS,
  PROCESSMETHOD_PRINTING_SLS,
  PROCESSMETHOD_MOLDING_INJECTION,
  PROCESSMETHOD_MOLDING_DOUBLE_INJECTION,
  PROCESSMETHOD_MOLDING_BLOW_INJECTION,
  PROCESSMETHOD_MOLDING_INSERT_INJECTION,
  PROCESSMETHOD_SHEETMETAL_PRESS,
  PROCESSMETHOD_SHEETMETAL_LASER_CUTTING,
  PROCESSMETHOD_SHEETMETAL_WATERJET_CUTTING,
  PROCESSMETHOD_CASTING_SAND,
  PROCESSMETHOD_CASTING_SHELL,
  PROCESSMETHOD_CASTING_INVESTMENT,
  PROCESSMETHOD_CASTING_DIE,
  PROCESSMETHOD_CASTING_CENTRIFUGAL
};

export {
  HERO,
  HERO_MD,
  HERO_XS,
  CLIENTS,
  CLIENTS_XS,
  BLOG_CARD_1,
  BLOG_CARD_2,
  BLOG_CARD_3,
  STEP_BUTTON_1,
  STEP_BUTTON_2,
  STEP_BUTTON_3,
  STEP_BUTTON_4,
  capabilityImages,
  processmethodImages,
  processImages,
  QUESTION_Q,
  ANSWER_A,
  TECH_INSIDE_BACKGROUND,
  TECH_INSIDE_MIDDLE_PNG
};
